import { render, staticRenderFns } from "./ProfileDetailCard.vue?vue&type=template&id=6a3c82e6"
import script from "./ProfileDetailCard.vue?vue&type=script&lang=js"
export * from "./ProfileDetailCard.vue?vue&type=script&lang=js"
import style0 from "./ProfileDetailCard.vue?vue&type=style&index=0&id=6a3c82e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports